interface ProcessStep {
  icon: string;
  step: string;
  title: string;
  description: string;
}

interface ServiceProcessProps {
  title: string;
  subtitle: string;
  steps: ProcessStep[];
  theme?: 'dark' | 'light';
  accentColor?: string;
}

const ServiceProcess = ({
  title,
  subtitle,
  steps,
  theme = 'dark',
  accentColor = '#00D9FF',
}: ServiceProcessProps) => {

  return (
    <section className="py-24 overflow-hidden bg-sf">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="mb-16 scroll-reveal">
          <span
            className="inline-block text-[11px] font-semibold uppercase tracking-[3px] mb-4"
            style={{ color: accentColor }}
          >
            How It Works
          </span>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <h2 className="text-3xl lg:text-4xl font-black max-w-md text-[var(--tp)]">
              {title}
            </h2>
            <p className="text-[15px] max-w-sm lg:text-right text-[var(--tm)]">
              {subtitle}
            </p>
          </div>
        </div>

        {/* Steps */}
        <div className="relative">
          <div
            className="absolute top-[52px] left-[calc((100%/5)/2)] right-[calc((100%/5)/2)] h-[1px] hidden lg:block pointer-events-none"
            style={{ background: `linear-gradient(to right, transparent, ${accentColor}30, ${accentColor}30, transparent)` }}
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-4">
            {steps.map((step, i) => (
              <div key={i} className={`scroll-reveal scroll-delay-${Math.min(i + 1, 6)} flex flex-col items-center lg:items-center text-center gap-4 group`}>
                <div className="relative flex-shrink-0">
                  <div
                    className="w-[52px] h-[52px] rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110 relative z-10"
                    style={{
                      background: `linear-gradient(135deg, ${accentColor}18 0%, rgba(10,22,40,0.8) 100%)`,
                      border: `2px solid ${accentColor}40`,
                      boxShadow: `0 0 20px ${accentColor}15`,
                    }}
                  >
                    <i className={`${step.icon} text-lg`} style={{ color: accentColor }} />
                  </div>
                  <div
                    className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-black z-20"
                    style={{ background: accentColor, color: '#0A1628' }}
                  >
                    {i + 1}
                  </div>
                </div>
                <span
                  className="text-[10px] font-bold uppercase tracking-[2px]"
                  style={{ color: accentColor }}
                >
                  {step.step}
                </span>
                <div>
                  <h3 className="text-[15px] font-bold mb-2 text-[var(--tp)]">{step.title}</h3>
                  <p className="text-[13px] leading-relaxed text-[var(--tm)]">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceProcess;
